import { b as __awaiter, c as __generator } from '../../tslib.es6-c6da0ae6.js';
import { GEO_ZONE_KEY, X_APP_AUTHORIZATION, RequestHeaders } from '../../configs/constants/index.js';
import { getObjectFromLocalStorage, setObjectToLocalStorage } from '../browserStorage/index.js';

var fetchGeoZone = function fetchGeoZone() {
  return __awaiter(void 0, void 0, void 0, function () {
    var API_URL, get, _a, status, response, _b, country, city, country_code, geoZoneInfo;
    var _c;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          return [4, import('../../configs/constants/index.js')];
        case 1:
          API_URL = _d.sent().API_URL;
          return [4, import('../../Fetch/index.js')];
        case 2:
          get = _d.sent()["default"].get;
          return [4, get("".concat(API_URL, "/location"), X_APP_AUTHORIZATION ? (_c = {}, _c[RequestHeaders.xAppAuthorizationToken] = X_APP_AUTHORIZATION, _c) : {})];
        case 3:
          _a = _d.sent(), status = _a.status, response = _a.response;
          if (status === 'success') {
            _b = (response === null || response === void 0 ? void 0 : response.resolved_location) || {}, country = _b.country, city = _b.city, country_code = _b.country_code;
            geoZoneInfo = {
              country: country,
              city: city,
              country_code: country_code
            };
            setObjectToLocalStorage(GEO_ZONE_KEY, geoZoneInfo);
            return [2, geoZoneInfo];
          }
          return [2, null];
      }
    });
  });
};
var getGeoZone = function getGeoZone() {
  return __awaiter(void 0, void 0, void 0, function () {
    var storageGeoZone;
    return __generator(this, function (_a) {
      storageGeoZone = getObjectFromLocalStorage(GEO_ZONE_KEY);
      if (storageGeoZone) {
        fetchGeoZone()["catch"](console.error);
        return [2, storageGeoZone];
      }
      return [2, fetchGeoZone()];
    });
  });
};

export { getGeoZone as default };
//# sourceMappingURL=index.js.map
